import React from "react";
import {
  convertStraight,
  convertThenFormat,
  formatDateTimezon,
} from "../../../common-data/Converts";
import { CheckCircleIcon, XCircleIcon } from "../../../../images/icons/icons";
import "../../../../styles/transfer/transfer-details.css";

const ViewDetails = ({
  rowData,
  isMembershipTransfer,
  isPaymentLinkListings,
}) => {
  const isPending = rowData?.status === "pending";
  const isApproved = rowData?.status === "approved";
  const isRejected = rowData?.status === "rejected";
  const isPrimaryMemberApproved = rowData?.user_from_approval;

  return (
    <div className="user-profile-container staff-onboarding-detail-modal transfers">
      <div className="user-profile-details">
        {isMembershipTransfer && (
          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">
                {rowData?.user_from_name || "primary member"}'s approval
              </p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {isPrimaryMemberApproved ? (
                  <CheckCircleIcon />
                ) : (
                  <XCircleIcon />
                )}
              </p>
            </div>
          </div>
        )}

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Payment by</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {rowData?.payment_by === "self"
                ? rowData?.user_from_name || "NA"
                : rowData?.payment_by === "receiver"
                ? rowData?.user_to_name || "NA"
                : "NA"}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">transferred by</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {rowData?.transfered_by_name || "NA"}
              <br />
              <small className="lowercase underline gray">
                {rowData?.transfered_by_mobile || ""}
                <br />
                {rowData?.transfered_by_email || ""}
              </small>
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">transfer date</p>
          </div>
          <div className="user-details-info">
            <p className="info-name icon">
              {rowData?.date_added
                ? formatDateTimezon(rowData.date_added)
                : "-"}
            </p>
          </div>
        </div>

        {(isPaymentLinkListings && rowData?.aprv_rej_by) ||
        !isPaymentLinkListings ? (
          <>
            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">
                  {isApproved || (isPaymentLinkListings && rowData?.aprv_rej_by)
                    ? "approved by"
                    : isRejected
                    ? "rejected by"
                    : "approval by"}
                </p>
              </div>
              <div className="user-details-info">
                <p className="info-name">
                  {isPending ? (
                    "pending"
                  ) : (
                    <>
                      {rowData?.aprv_rej_by_name || "NA"}
                      <br />
                      <small className="lowercase underline gray">
                        {rowData?.aprv_rej_by_mobile || ""}
                        <br />
                        {rowData?.aprv_rej_by_email || ""}
                      </small>
                    </>
                  )}
                </p>
              </div>
            </div>

            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">
                  {isApproved
                    ? "approved remarks"
                    : isRejected
                    ? "rejected remarks"
                    : "approval remarks"}
                </p>
              </div>
              <div className="user-details-info">
                <p className="info-name">
                  {isPending ? "pending" : rowData?.aprv_rej_remarks || "NA"}
                </p>
              </div>
            </div>

            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">
                  {isApproved
                    ? "approved date"
                    : isRejected
                    ? "rejected date"
                    : "approval date"}
                </p>
              </div>
              <div className="user-details-info">
                <p className="info-name icon">
                  {isPending
                    ? "pending"
                    : rowData?.aprv_rej_date
                    ? formatDateTimezon(rowData.aprv_rej_date)
                    : "-"}
                </p>
              </div>
            </div>
          </>
        ) : null}

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">transfer fee</p>
          </div>
          <div className="user-details-info">
            <p className="info-name icon">
              ₹{convertThenFormat(rowData?.base_transfer_fee || 0)}
            </p>
          </div>
        </div>

        {!isMembershipTransfer && (
          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">total transfer cost</p>
            </div>
            <div className="user-details-info">
              <p className="info-name icon">
                ₹{convertThenFormat(rowData?.transfered_fee || 0)}
              </p>
            </div>
          </div>
        )}

        {/* {!isMembershipTransfer && (
          <>
            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">gym from</p>
              </div>
              <div className="user-details-info">
                <p className="info-name icon">
                  {rowData?.gym_from_name || "NA"}
                </p>
              </div>
            </div>

            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">gym to</p>
              </div>
              <div className="user-details-info">
                <p className="info-name icon">{rowData?.gym_to_name || "NA"}</p>
              </div>
            </div>
          </>
        )} */}
      </div>

      {isMembershipTransfer ? (
        <div className="transfer-details-grid">
          {rowData?.regular_plans?.map((item, index) => (
            <div className="transfer-details-row" key={index}>
              <div className="transfer-box">
                <h3 className="transfer-box-head">Transferred From</h3>

                <div className="user-profile-details">
                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">Member Name</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">
                        {item?.user_name || rowData?.user_from_name || "NA"}
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">gym</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">
                        {item?.gym_name || rowData?.gym_from_name || "NA"}
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">Plan Name</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">{item?.plan_name || "NA"}</p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">Start date</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">
                        {item?.old_start_date
                          ? convertStraight(item?.old_start_date)
                          : "NA"}
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">expiry date</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">
                        {item?.old_expire_date
                          ? convertStraight(item?.old_expire_date)
                          : "NA"}
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">status</p>
                    </div>
                    <div className="user-details-info">
                      <p
                        className={`info-name status-badge ${item?.subscription_status?.toLowerCase()}`}>
                        {item?.subscription_status?.replace(/_/g, " ") || "NA"}
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">amount</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">
                        ₹{convertThenFormat(item?.price || 0)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="transfer-box">
                <h3 className="transfer-box-head">Transferred To</h3>

                <div className="user-profile-details">
                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">Member Name</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">
                        {item?.child_user_name || rowData?.user_to_name || "NA"}
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">gym</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">
                        {item?.child_gym_name || rowData?.gym_to_name || "NA"}
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">Plan Name</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">
                        {item?.child_plan_name || item?.plan_name || "NA"}
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">Start date</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">
                        {item?.child_start_date
                          ? convertStraight(item?.child_start_date)
                          : item?.start_date
                          ? convertStraight(item?.start_date)
                          : "NA"}
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">expiry date</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">
                        {item?.child_expire_date
                          ? convertStraight(item?.child_expire_date)
                          : item?.expire_date
                          ? convertStraight(item?.expire_date)
                          : "NA"}
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">status</p>
                    </div>
                    <div className="user-details-info">
                      <p
                        className={`info-name status-badge ${
                          item?.child_subscription_status?.toLowerCase() ||
                          item?.subscription_status?.toLowerCase()
                        }`}>
                        {item?.child_subscription_status?.replace(/_/g, " ") ||
                          item?.subscription_status?.replace(/_/g, " ") ||
                          "NA"}
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">amount</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">
                        ₹
                        {convertThenFormat(
                          item?.child_price || item?.price || 0
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="transfer-details-grid">
          {rowData?.regular_plans?.map((item, index) => (
            <div className="transfer-details-row" key={index}>
              <div className="transfer-box">
                <h3 className="transfer-box-head">Transferred From</h3>

                <div className="user-profile-details">
                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">gym Name</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">
                        {rowData?.gym_from_name || "NA"}
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">plan Name</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">{item?.plan_name || "NA"}</p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">Start date</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">
                        {item?.old_start_date
                          ? convertStraight(item?.old_start_date)
                          : "NA"}
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">expiry date</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">
                        {item?.old_expire_date
                          ? convertStraight(item?.old_expire_date)
                          : "NA"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="transfer-box">
                <h3 className="transfer-box-head">Transferred To</h3>

                <div className="user-profile-details">
                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">Member Name</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">
                        {rowData?.gym_to_name || "NA"}
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">plan Name</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">{item?.plan_name || "NA"}</p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">Start date</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">
                        {item?.child_start_date
                          ? convertStraight(item?.child_start_date)
                          : item?.start_date
                          ? convertStraight(item?.start_date)
                          : "NA"}
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <div className="user-details-head">
                      <p className="head-name">expiry date</p>
                    </div>
                    <div className="user-details-info">
                      <p className="info-name">
                        {item?.child_expire_date
                          ? convertStraight(item?.child_expire_date)
                          : item?.expire_date
                          ? convertStraight(item?.expire_date)
                          : "NA"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ViewDetails;
